import { Trans, useTranslation } from "@repo/shared/i18n";
import React, { useEffect } from "react";
import { NavLink } from "react-router";

interface FaqItemProps {
  question: string;
  children: React.ReactNode;
}

const FaqItem = ({ question, children }: FaqItemProps) => (
  <div className="mb-8">
    <h3 className="font-bold text-xl mb-2">{question}</h3>
    <div className="text-lg leading-relaxed">{children}</div>
  </div>
);

const Faq = () => {
  const { t } = useTranslation("company");
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="container mx-auto px-4 py-8 text-white">
      <h1 className="text-4xl font-bold text-center mb-8">{t("faq.title")}</h1>
      <FaqItem question={t("faq.import.question")}>
        <p>{t("faq.import.answer")}</p>
      </FaqItem>

      <FaqItem question={t("faq.safety.question")}>
        <p className="mb-4">
          <Trans
            ns="company"
            i18nKey="faq.safety.intro"
            components={{
              textLink: (
                <a
                  href="https://help.ea.com/en/help/fifa/fifa-rules/#connecting-to-ea"
                  target="_blank"
                  rel="noreferrer"
                  className="text-blue-400 underline"
                />
              ),
            }}
          />
        </p>
        <p>{t("faq.safety.answer")}</p>
      </FaqItem>

      <FaqItem question={t("faq.contact.question")}>
        <p>
          <Trans
            ns="company"
            i18nKey="faq.contact.answer"
            components={{
              textLink: (
                <NavLink to="/contact" className="text-blue-400 underline" />
              ),
            }}
          />
        </p>
      </FaqItem>
    </main>
  );
};

export default Faq;
